import React from "react";
import { MdOutlineRocket } from "react-icons/md";
import { PiRocket } from "react-icons/pi";

const ComingSoon = ({ height }) => {
  return (
    <div
      style={{
        position: 'absolute',
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: height ? height : "180px",
        flexDirection: "column",
      }}
    >
      <PiRocket style={{fontSize: '26px'}}/>
      <p style={{fontSize: '18px', fontStyle: 'italic'}} className="m-0">Plans are launching soon...</p>
    </div>
  );
};

export default ComingSoon;
